import React, { FunctionComponent } from 'react';
import { Grid } from '@rbx/ui';
import { TParameter } from '@rbx/docsite-utilities/dist/browser';
import SchemaTableRow from './SchemaTableRow';

export interface ParametersProps {
  className?: string;
  parameters?: TParameter[];
}

const Parameters: FunctionComponent<React.PropsWithChildren<ParametersProps>> = ({
  parameters = [],
  className,
}) => {
  return (
    <Grid container direction='column' className={className}>
      {parameters.map((item) => (
        // @ts-expect-error FIXME: The types here are pretty messed up
        // (eg: format isn't defined, but totally exists on plenty of parameters)
        <SchemaTableRow key={item.name} schemaItem={item} />
      ))}
    </Grid>
  );
};

export default Parameters;
